import { ThemeColorNames } from '@sites/site-theme/src/enums/color-names.enum';

export const THEME_COLORS_VARIABLES: Record<ThemeColorNames, string> = {
    [ThemeColorNames.light]: '--light-color',
    [ThemeColorNames.dark]: '--dark-color',
    [ThemeColorNames.primary]: '--primary-color',
    [ThemeColorNames.secondary]: '--secondary-color',
    [ThemeColorNames.accent]: '--accent-color',
};
